module.exports = {
  siteTitle: 'Tara Wilson', // <title>
  manifestName: 'Tara Wilson',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  pathPrefix: `/portfolio-resume/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Tara Wilson',
  subHeading: 'Software Engineer',
  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/tara-wilson',
    },
    {
      icon: 'fa-linkedin',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/tarawilson3/',
    },
  ],
  emailId: '1tarawilson@gmail.com',
  phone: '(240) 274-8755',
  address: 'Washington, D.C. / New York City',
};
